import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";


interface ParentescoState {
    status: string;
    error: string;
    parentescoList: any[],
    parentescoListActive: any[],
    parentesco: {
        idParentesco: number | null;
        nombre: string | null;
    }

}

const initialState: ParentescoState = {
    status: 'idle',
    error: '',
    parentescoList: [],
    parentescoListActive: [],
    parentesco: {
        idParentesco: null,
        nombre: null
    }
}

export const fetchParentesco = createAsyncThunk('fetchParentesco', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 49;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchParentescoActive = createAsyncThunk('fetchParentescoActive', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 50;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});


export const parentescoSlice = createSlice({
    name: 'parentesco',
    initialState,
    reducers: {
        setParentescoList: (state, action) => {
            state.parentescoList = action.payload;
        },
        setParentescoListActive: (state, action) => {
            state.parentescoListActive = action.payload;
        },
        setParentesco: (state, action) => {
            state.parentesco = !action.payload ? initialState.parentesco : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchParentesco.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchParentesco.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.parentescoList = data ? data : [];

            })
            .addCase(fetchParentesco.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchParentescoActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchParentescoActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.parentescoListActive = data ? data : [];

            })
            .addCase(fetchParentescoActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectParentescoList = (state: RootState) => state.parentesco.parentescoList;
export const selectParentescoListActive = (state: RootState) => state.parentesco.parentescoListActive;
export const selectParentesco = (state: RootState) => state.parentesco.parentesco;

export const { setParentescoList, setParentescoListActive, setParentesco } = parentescoSlice.actions;

export default parentescoSlice.reducer;



